import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './styles.scss';

const GeoLocationCheck = ({ displayHeader }) => {
    const [ t ] = useTranslation();

    return (
        <div className="betslip__geo-check">
            {displayHeader
                ? <div className="betslip__geo-check-header">{t('betslip.please_wait')}</div>
                : null
            }
            <span className="betslip__geo-check-message">{t('betslip.verifying_location')}</span>
        </div>
    );
};

GeoLocationCheck.propTypes = {
    displayHeader: PropTypes.bool,
};

GeoLocationCheck.defaultProps = {
    displayHeader: true,
};

export default GeoLocationCheck;
